import application from 'application/application';

application

	.value('re', {
		// https://www.w3.org/TR/html5/sec-forms.html#valid-e-mail-address
		mail: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
		numeric: /^\-?\d+(?:\.\d+)?$/,
		positive: /^\d+(?:\.\d+)?$/,
		negative: /^\-\d+(?:\.\d+)?$/,
		words: /^[a-zA-Z\u00C0-\u00FF\s]+$/i,
		integer: /^\d+$/
	});
